import type { SmartLinkType } from './getSmartLinks.ts';

export function compareIcons(
	gqlState: Record<string, any>,
	orsState: Record<string, any>,
	links: SmartLinkType[],
) {
	const linksByUrl = new Map<string, SmartLinkType>();
	for (const link of links) {
		if (link.resourceUrl) {
			linksByUrl.set(link.resourceUrl, link);
		}
	}

	let matchedCount = 0;

	const byType: Record<
		string,
		{ total: number; matched: number; missingIcon: number; wrongIcon: number }
	> = {};

	for (const url of Object.keys(gqlState)) {
		const ors = orsState[url];
		const link = linksByUrl.get(url);
		const typeKey = [link?.resourceType, link?.subType].filter(Boolean).join('/') || 'unknown';

		if (!byType[typeKey]) {
			byType[typeKey] = { total: 0, matched: 0, missingIcon: 0, wrongIcon: 0 };
		}
		byType[typeKey].total++;

		if (!ors) {
			continue;
		}

		const gqlIcon = gqlState[url].details?.data?.icon?.url ?? null;
		const orsIcon = ors.details?.data?.icon?.url ?? null;

		if (gqlIcon !== orsIcon) {
			if (gqlIcon === null) {
				byType[typeKey].missingIcon++;
			} else {
				byType[typeKey].wrongIcon++;
			}
		} else {
			matchedCount++;
			byType[typeKey].matched++;
		}
	}

	return { matchedCount, byType };
}
